module.exports = __webpack_public_path__ + "img/customers.2460fc4e.svg";